// extracted by mini-css-extract-plugin
export default {"root":"time-items_root__321OJ","item":"time-items_item__59BC3","selected":"time-items_selected__6eaQX","disabled":"time-items_disabled__AkpHo"};